import React, { useContext, useState, useEffect, useRef } from 'react';
import { StoreContext } from '../context/store-context';
import Price from './price';
import Quantity from './quantity';
import { variantIsOnSale } from '../utils/helpers';
import { Link } from 'gatsby';
import Image from './image';

const AddToCartForm = ({ product, variantId, setIsOnSale, productPage = false, searchPage, mainProduct, locationCategory, productDescription, listProduct = false }) => {
  const {
    cart,
    addVariantToCart,
    setConCurrentVariant,
    setLightboxOpen,
    setLightboxContent,
    setLightboxClass,
  } = useContext(StoreContext);

  const [currentVariant, setCurrentVariant] = useState(product.variants ? product.variants[0] : null);
  const [loading, setLoading] = useState(false);
  const [isAvailable, setIsAvailable] = useState(true);
  const variantType = product.variants?.length > 0 ? product.variants[0].selectedOptions[0].name : null;
  const addToCartForm = useRef(null);
  const options = product.options || null;

  const [selectedType, setSelectedType] = useState(0);
  const [selectedCutting, setSelectedCutting] = useState(0);
  const [selectedWidth, setSelectedWidth] = useState(null);
  const [selectedThickness, setSelectedThickness] = useState(null);
  const [widthOptions, setWidthOptions] = useState([]);
  const [thicknessOptions, setThicknessOptions] = useState([]);
  const [availableThicknessOptions, setAvailableThicknessOptions] = useState([]);
  const [selectedVariants, setSelectedVariants] = useState([]);
  const variantZero = product.variants[0]?.selectedOptions[0].name.toLowerCase();
  const variantOne = product.variants[0]?.selectedOptions[1]?.name.toLowerCase();

  let allOptions = [];
  product.variants?.forEach((variant) => {
    allOptions.push({
      'name': variant.storefrontId,
      'label': variant.title,
      'available': variant.availableForSale
    });
  });

  let typeOptions = []
  let cuttingOptions = []
  if (options && options.length > 0) {
    options.forEach((op) => {
      if (op.name === 'Type') {
        op.values.forEach(val => {
          typeOptions.push(val)
        })
      }
      if (op.name === 'Cutting Service' || op.name === 'Cutting Services' || op.name === 'Cutting Service (optional)') {
        op.values.forEach(val => {
          if (product.variants.find(v => v.title === val)?.storefrontId) {
            cuttingOptions.push({
              value: product.variants.find(v => v.title === val)?.storefrontId,
              label: val
            })
          }
        })
      }
    })
  }

  useEffect(() => {
    const widths = new Set();
    const thicknesses = new Set();

    product.variants.forEach(variant => {
      variant.selectedOptions.forEach(option => {
        if (option.name.toLowerCase().includes('width')) {
          widths.add(option.value);
        }
        if (option.name.toLowerCase().includes('thickness')) {
          thicknesses.add(option.value);
        }
      });
    });

    setWidthOptions([...widths]);
    setThicknessOptions([...thicknesses]);
  }, [product.variants]);

  useEffect(() => {
    if (selectedWidth) {
      const newThicknessOptions = product.variants
        .filter(variant =>
          variant.selectedOptions.some(option =>
            option.name.toLowerCase().includes('width') && option.value === selectedWidth
          )
        )
        .map(variant => ({
          value: variant.selectedOptions.find(option => option.name.toLowerCase().includes('thickness'))?.value,
          available: variant.availableForSale
        }))
        .filter(thickness => thickness.value);

      setAvailableThicknessOptions(newThicknessOptions);

      const existingThickness = newThicknessOptions.find(thickness => thickness.value === selectedThickness && thickness.available);

      if (existingThickness) {
        setSelectedThickness(existingThickness.value);
      } else {
        const firstAvailableThickness = newThicknessOptions.find(thickness => thickness.available)?.value;
        setSelectedThickness(firstAvailableThickness);
        updateCurrentVariant(selectedWidth, firstAvailableThickness);
      }
    } else {
      setAvailableThicknessOptions(thicknessOptions.map(thickness => ({ value: thickness, available: true })));
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [selectedWidth, product.variants, thicknessOptions, selectedThickness])

  useEffect(() => {
    if (widthOptions.length > 0 && thicknessOptions.length > 0) {
      const initialWidth = widthOptions[0];
      setSelectedWidth(initialWidth);
      const newThicknessOptions = [];
      product.variants.forEach(variant => {
        if (variant.selectedOptions.some(option => option.name.toLowerCase().includes('width') && option.value === initialWidth)) {
          variant.selectedOptions.forEach(option => {
            if (option.name.toLowerCase().includes('thickness')) {
              newThicknessOptions.push({
                value: option.value,
                available: variant.availableForSale
              });
            }
          });
        }
      });
      setAvailableThicknessOptions(newThicknessOptions);
      const firstAvailableThickness = newThicknessOptions.find(option => option.available);
      if (firstAvailableThickness) {
        setSelectedThickness(firstAvailableThickness.value);
        updateCurrentVariant(initialWidth, firstAvailableThickness.value);
      }
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [widthOptions, thicknessOptions, product.variants]);

  const handleWidthChange = (e) => {
    const newWidth = e.target.value;
    setSelectedWidth(newWidth);

    const newThicknessOptions = product.variants
      .filter(variant =>
        variant.selectedOptions.some(option =>
          option.name.toLowerCase().includes('width') && option.value === newWidth
        )
      )
      .map(variant => ({
        value: variant.selectedOptions.find(option => option.name.toLowerCase().includes('thickness'))?.value,
        available: variant.availableForSale
      }))
      .filter(thickness => thickness.value !== undefined);

    setAvailableThicknessOptions(newThicknessOptions);

    const existingThickness = newThicknessOptions.find(thickness => thickness.value === selectedThickness && thickness.available);
    const firstAvailableThickness = existingThickness || newThicknessOptions.find(thickness => thickness.available);

    if (firstAvailableThickness) {
      setSelectedThickness(firstAvailableThickness.value);
      updateCurrentVariant(newWidth, firstAvailableThickness.value);
    } else {
      setSelectedThickness(null);
    }
  };


  const handleThicknessChange = (e) => {
    const newThickness = e.target.value;
    setSelectedThickness(newThickness);
    updateCurrentVariant(selectedWidth, newThickness);
  }

  const updateCurrentVariant = (width, thickness) => {
    const matchedVariant = product.variants.find(variant =>
      variant.selectedOptions.some(option => option.name.toLowerCase().includes('width') && option.value === width) &&
      variant.selectedOptions.some(option => option.name.toLowerCase().includes('thickness') && option.value === thickness)
    );

    if (matchedVariant) {
      setCurrentVariant(matchedVariant);
      setConCurrentVariant(matchedVariant);
      setIsAvailable(matchedVariant.availableForSale);
    } else {
      setIsAvailable(false);
    }
  }

  const changeVariation = (e, newVariant, type) => {
    if (!newVariant && type === "type") {
      newVariant = e.target.value;
    } else if (!newVariant && type === "cutting") {
      newVariant = e.value;
    }
    newVariant = type === "type" || !type ? e.target.value : e.value;

    let parent = ""
    if (type === 'type') {
      parent = newVariant + ' / ' + selectedCutting
      setSelectedType(newVariant)
    }

    if (type === 'cutting') {
      parent = product.variants.find(v => v.title === e.value)?.title
      setSelectedCutting(newVariant.storefrontId)
    }

    product.variants.every((variant) => {
      if (variant.storefrontId === newVariant || parent === variant.title) {
        setCurrentVariant(variant);
        setConCurrentVariant(variant);
        setIsAvailable(variant.availableForSale);
        return false;
      }
      return true;
    })
  }

  const addToCart = (e) => {
    e.preventDefault();
    setLoading(true);
    const qtyInput = addToCartForm.current.querySelector('.Quantity__input');
    const qty = qtyInput ? qtyInput.value : 1;
    if(!searchPage) {
      addVariantToCart(currentVariant.storefrontId, qty);
    } else {
      addVariantToCart(variantId, qty);
    }
  }

  useEffect(() => {
    setLoading(false);
  }, [cart])

  useEffect(() => {
    if (setIsOnSale) {
      setIsOnSale(variantIsOnSale(currentVariant));
    }
  }, [currentVariant, setIsOnSale])

  // const CuttingPopup = () => {
  //   return (
  //     <div className='Popup'>
  //       <h2>Add-On Cutting Services</h2>
  //       <p><strong>If you have any questions, please visit our <Link to="/contact" >contact page</Link> or call us at our toll free number <a href="tel:+(800) 258-4585">(800) 258-4585</a>.</strong></p>
  //     </div>
  //   )
  // }

  // Comparison
  // const handleAddToCompare = () => {
  //   if (!selectedVariants.includes(currentVariant.storefrontId) && selectedVariants.length < 4) {
  //     setSelectedVariants(prev => [...prev, currentVariant.storefrontId]);
  //   }
  // }

  // const isCompareButtonDisabled = () => {
  //   return selectedVariants.includes(currentVariant.storefrontId) || selectedVariants.length >= 4;
  // }

  const ComparisonPopup = () => {
    return (
      <div className={`Comparison__popup__inner class-for-${selectedVariants.length}`}>
        {selectedVariants.map(variantId => {
          const variant = product.variants.find(v => v.storefrontId === variantId);
          return (
            <div className='Comparison__popup__inner__item' key={variantId}>
              <Image source={variant.media[0]?.image.src} />
              <h3>{variant.title}</h3>
              <Price product={product} variant={variant} />
              <button className='Button Button__secondary' onClick={() => addVariantToCart(variantId, 1)}>Add to Cart</button>
            </div>
          );
        })}
      </div>
    );
  }

  const toggleVariantSelection = (variantId) => {
    if (selectedVariants.includes(variantId)) {
      setSelectedVariants(selectedVariants.filter(id => id !== variantId));
    } else if (selectedVariants.length < 4) {
      setSelectedVariants(prev => [...prev, variantId]);
    }
  }

  const renderCompareButton = () => {
    if (selectedVariants.length <= 4 && selectedVariants.length > 1) {
      return (
        <button type='button' className="Comparison__button__show Button Button__primary" onClick={() => {
          setLightboxClass('Comparison__popup');
          setLightboxOpen(true);
          setLightboxContent(<ComparisonPopup />);
        }}>
          Show Comparison
        </button>
      );
    }
    return null;
  }

  const renderAddToCompareButton = (variant) => {
    return (
      <button
        className='Comparison__button__add Button Button__primary'
        type='button'
        disabled={selectedVariants.length >= 4 && !selectedVariants.includes(variant.storefrontId)}
        onClick={() => toggleVariantSelection(variant.storefrontId)}
      >
        {selectedVariants.includes(variant.storefrontId) ? 'Remove from Compare' : 'Add to Compare'}
      </button>
    );
  }
  // End Comparison

  useEffect(() => {
    if (variantId && searchPage) {
      const variant = product.variants.find(v => v.storefrontId === variantId);
      setCurrentVariant(variant);
      setConCurrentVariant(variant);
    } else {
      setCurrentVariant(product.variants ? product.variants[0] : null);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [product, variantId, searchPage]);


  return (
    <>
      {currentVariant && currentVariant.sku && !searchPage && !listProduct && (
        <div className="ProductPage__content__code">Product Code: {currentVariant.sku}</div>
      )}

      <form
        className="AddToCart"
        onSubmit={addToCart}
        noValidate
        ref={addToCartForm}
      >
        <Price
          product={product}
          variant={currentVariant}
          variantPrice={product.currentVarVal?.price}
          productPage={productPage}
          searchPage={searchPage}
          mainProduct={mainProduct}
          locationCategory={locationCategory}
        />

        {productDescription && (
          <div className="ProductPage__content__description">
            <h6>About This Product</h6>
            <div dangerouslySetInnerHTML={{__html: productDescription }} />
            <Link
              to="#overview"
              className="ProductPage__content__description--more"
            >View More Information</Link>
          </div>
        )}

        {!product.hasOnlyDefaultVariant && (
        <>
          {typeOptions.length > 0 && (
            <div className="AddToCart__variants__radio" hidden={productPage}>
              <label htmlFor="size" className="ScreenReader">{variantType}</label>
              <div className="AddToCart__variants__inner">
                {typeOptions.map((el, index) => (
                  <div className={`AddToCart__variants__radio--field${selectedVariants.includes(product.variants.find(v => v.title === el)?.storefrontId) ? ' Comparison__added' : ''}`} key={index}>
                    <input type="radio"
                      name="type"
                      id={'type-' + index}
                      value={el}
                      onChange={(e) => changeVariation(e, el, "type")}
                      checked={selectedType === el ? true : false}
                    />
                    <label htmlFor={'type-' + index}>{el}</label>
                  </div>
                ))}
              </div>
            </div>
          )}

          {cuttingOptions.length > 0 && !listProduct && (
            // <div className="AddToCart__variants__cutting" hidden={productPage}>
            //   <label htmlFor="size" className="ScreenReader">Add-on Cutting Service (optional)
            //     <button
            //       className="AddToCart__variants__cutting--tooltip notbutton"
            //       onClick={(e) => {
            //         e.preventDefault()
            //         setLightboxOpen(true);
            //         setLightboxContent(<CuttingPopup />)
            //       }}>?</button></label>

            //   <Dropdown options={cuttingOptions} onChange={(e) => changeVariation(e, false, "cutting")} value={selectedCutting} placeholder="Select a Cut" />
            // </div>
            <p className='ProductPage__content__afterAddToCart'>
              <p>
                <Link to={`/contact`}>Contact us</Link> about cutting your untreated lumber down for transport.
              </p>
            </p>
          )}

          {allOptions.length > 1 && variantType !== 'Cutting Service' && variantType !== 'Cutting Services' && variantType !== 'Cutting Service (optional)' && !(variantZero.includes('width') && variantOne.includes('thickness')) && !(variantZero.includes('thickness') && variantOne.includes('width')) && (
            <div className="AddToCart__variants__radio" hidden={productPage}>
              <label htmlFor="size" className="ScreenReader">{variantType}</label>
              <div className="AddToCart__variants__inner">
                {allOptions.map((option, index) => (
                  <div className={`AddToCart__variants__radio--field${!option.available ? ' disable' : ''}${selectedVariants.includes(option.name) ? ' Comparison__added' : ''}`} key={index} >
                    <input type="radio"
                      name="option"
                      id={'option-' + index}
                      value={option.name}
                      onChange={(e) => changeVariation(e, index)}
                      checked={currentVariant.storefrontId === option.name ? true : false}
                    />
                    <label htmlFor={'option-' + index}>{option.label}</label>
                  </div>
                ))}
              </div>
            </div>
          )}
          {allOptions.length > 1 && variantType !== 'Cutting Service' && variantType !== 'Cutting Services' && variantType !== 'Cutting Service (optional)' && ((variantZero.includes('width') && variantOne.includes('thickness')) || (variantZero.includes('thickness') && variantOne.includes('width'))) && (
            <>
              <div className="AddToCart__variants__radio width-thickness" hidden={productPage}>
                <label htmlFor="width">Width</label>
                <div className="AddToCart__variants__inner">
                  {widthOptions.map((width, index) => (
                    <div className={`AddToCart__variants__radio--field${!isAvailable ? ' disable' : ''}${selectedVariants.includes(product.variants.find(v => v.selectedOptions.some(option => option.name.toLowerCase() === 'width' && option.value === width))?.storefrontId) ? ' Comparison__added' : ''}`} key={index}>
                      <input
                        type="radio"
                        name="width"
                        id={`width-${index}`}
                        value={width}
                        onChange={handleWidthChange}
                        checked={selectedWidth === width}
                        disabled={!isAvailable}
                      />
                      <label htmlFor={`width-${index}`}>{width}</label>
                    </div>
                  ))}
                </div>
              </div>

              <div className="AddToCart__variants__radio width-thickness" hidden={productPage}>
                <label htmlFor="thickness">Thickness</label>
                <div className="AddToCart__variants__inner">
                  {availableThicknessOptions.map((option, index) => (
                    <div className={`AddToCart__variants__radio--field${!option.available ? ' disable' : ''}${selectedVariants.includes(product.variants.find(v => v.selectedOptions.some(opt => opt.name.toLowerCase() === 'thickness' && opt.value === option.value))?.storefrontId) ? ' Comparison__added' : ''}`} key={index}>
                      <input
                        type="radio"
                        name="thickness"
                        id={`thickness-${index}`}
                        value={option.value}
                        onChange={handleThicknessChange}
                        checked={selectedThickness === option.value}
                        disabled={!option.available}
                      />
                      <label htmlFor={`thickness-${index}`}>{option.value}</label>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </>
        )}

        {!productPage && variantType?.toLowerCase().includes('colo') && (
          <div className='Comparison__container'>
            {renderAddToCompareButton(currentVariant)}

            {renderCompareButton()}
          </div>
        )}

        <div className="AddToCart__actions">
          {!listProduct && (
            <div className="AddToCart__actions__wrap" hidden={productPage}>
              <Quantity product={product} noUpdate={true} />
            </div>
          )}
          <button
            type="submit"
            className="Button Button__secondary"
            disabled={!isAvailable || loading}
          >
            {!isAvailable ? 'Not available' : 'Add to Cart'}
          </button>
        </div>
      </form>
    </>
  )
}

export default AddToCartForm;
